import { flushSync } from 'react-dom';
import { NavigateFunction, NavigateOptions, To } from 'react-router-dom';

export const resetDocumentScrollTop = () => {
  window.scrollTo({ top: 0, behavior: 'auto' });
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
};

export const navigateWithScrollTop = (
  navigate: NavigateFunction,
  to: To,
  options?: NavigateOptions
) => {
  flushSync(() => {
    navigate(to, options);
  });

  resetDocumentScrollTop();
};